import MultiChoice from './MultiChoice';

export default MultiChoice;
